// extracted by css-extract-rspack-plugin
export default {"wrapper":"_23a20b51","hasError":"_4621a100","input":"_5b2abc14","icon":"_94f2f349","sellerIcon":"_b5457cc8 _94f2f349","label":"_2104b324","errorWrapper":"_3894b669"};